import React from 'react';
import { Container, Row, Col, Card } from 'react-bootstrap';
import { DollarSign, ShieldCheck, Award } from 'lucide-react';
import { useTranslation } from 'react-i18next';

const Features = () => {
  const { t } = useTranslation();

  const featureData = [
    {
      icon: <DollarSign size={40} color="#ffffff" />,
      title: t('features.items.cost.title'),
      description: t('features.items.cost.description')
    },
    {
      icon: <ShieldCheck size={40} color="#ffffff" />,
      title: t('features.items.ethics.title'),
      description: t('features.items.ethics.description')
    },
    {
      icon: <Award size={40} color="#ffffff" />,
      title: t('features.items.quality.title'),
      description: t('features.items.quality.description')
    }
  ];

  return (
    <section className="py-5" style={{ backgroundColor: 'var(--color-bg)' }}>
      <Container className="py-5">
        <div className="text-center mb-5 pb-3" data-aos="fade-up">
          <h6 className="text-uppercase mb-3" style={{ color: 'var(--color-accent)', letterSpacing: '2px', fontWeight: 'bold' }}>
            {t('features.subtitle')}
          </h6>
          <h2 className="display-6 fw-bold text-dark mb-3" style={{ fontFamily: 'var(--font-serif)' }}>
            {t('features.title')}
          </h2>
          <p className="text-dark opacity-75 mx-auto" style={{ maxWidth: '600px' }}>
            {t('features.description')}
          </p>
        </div>

        <Row className="g-4">
          {featureData.map((feature, index) => (
            <Col md={4} key={index} data-aos="fade-up" data-aos-delay={`${index * 150}`}>
              <Card 
                className="h-100 bg-transparent border-0 text-center text-dark" 
                style={{ 
                  backgroundColor: 'rgba(255,255,255,0.02) !important',
                  transition: 'transform 0.3s ease',
                  cursor: 'pointer'
                }}
                onMouseEnter={(e) => e.currentTarget.style.transform = 'translateY(-10px)'}
                onMouseLeave={(e) => e.currentTarget.style.transform = 'translateY(0)'}
              >
                <Card.Body className="p-4 d-flex flex-column align-items-center p-xl-5" style={{ background: 'var(--color-surface)', borderRadius: '8px', border: '1px solid rgba(255,255,255,0.05)' }}>
                  <div className="mb-4 p-3 rounded-circle" style={{ backgroundColor: '#abbdf3ff' }}>
                    {feature.icon}
                  </div>
                  <Card.Title className="mb-3 fs-3" style={{ fontFamily: 'var(--font-serif)' }}>
                    {feature.title}
                  </Card.Title>
                  <Card.Text className="text-dark opacity-50" style={{ lineHeight: '1.7' }}>
                    {feature.description}
                  </Card.Text>
                </Card.Body>
              </Card>
            </Col>
          ))}
        </Row>
      </Container>
    </section>
  );
};

export default Features;
